import { Component, inject, Input, OnInit } from '@angular/core';
import _ from 'lodash';

import { Chapter } from '../../../../models/chapter';
import { CommunicationService } from '../../../../services/communication.service';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { ChapterService } from '../../../../services/chapter.service';
import { PageService } from '../../../../services/page.service';
import { PageChangedEvent } from '../../../../utils/events/page-changed-event';
import { SidebarService } from '../../../../services/sidebar.service';
import { environment } from '../../../../../environments/environment';
import { MainChapterHeadingComponent } from '../../../utils/main-chapter-heading/main-chapter-heading.component';
import { CrudService } from '../../../../services/crud.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';

@Component({
    selector: 'sidebar-single-chapter-content',
    templateUrl: './single-chapter-content.component.html',
    styleUrls: ['./single-chapter-content.component.scss'],
    standalone: true,
    imports: [
        MainChapterHeadingComponent
    ]
})
export class SingleChapterContentComponent implements OnInit {

    @Input() chapter: Chapter;
    private crudService = inject(CrudService);
    showChapterNames: boolean;
    subchapterHierarchyMap: Map<number, Array<string | number>>;

    constructor(private chapterService: ChapterService,
                private pageService: PageService,
                private communicationService: CommunicationService,
                private sidebarService: SidebarService,
                private applicationStateService: ApplicationStateService) {
    }

    ngOnInit(): void {
        this.getHierarchy();
        this.subchapterHierarchyMap = new Map();
        this.showChapterNames = this.applicationStateService.bookConfig.chaptersOrderEnabled;
        this.chapter.subChapters = _.sortBy(this.chapter.subChapters, ele => {
            return ele.index;
        });
    }

    turnToPage(chapter: Chapter): void {
        this.crudService.logDirect(TechnicalFeature.Chapter);

        this.pageService.addToHistory(this.applicationStateService.currentIndex);
        const pageturnEvent = new PageChangedEvent();
        pageturnEvent.moveToPage = chapter.index;
        this.communicationService.announcePageTurn(pageturnEvent);

        if (window.window.innerWidth <= (environment.mobileBreakPoint + 1)) {
            this.sidebarService.closeSidebar();
        }
    }

    getRealPageNumber(chapter: Chapter): number {
        return this.pageService.getRealPageNumber(chapter.index);
    }

    private getHierarchy(): void {
        this.chapter.subChapters.forEach(currentChapter => {
            this.chapterService.getChapterHierarchyFromChapter(currentChapter).then(result => {
                this.subchapterHierarchyMap.set(currentChapter.id, result);
            });
        });
    }
}
